export default __webpack_public_path__ + "static/media/ea6f6a2b218056e86a67dd5d8002852a.svg";